import { render, staticRenderFns } from "./FormPublication.vue?vue&type=template&id=41a7917c&"
import script from "./FormPublication.vue?vue&type=script&lang=js&"
export * from "./FormPublication.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports